import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Paper,
  Grid,
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Box,
  IconButton,
} from "@mui/material";
import QuizIcon from "@mui/icons-material/Quiz";
import AssignmentIcon from "@mui/icons-material/Assignment";
import SchoolIcon from "@mui/icons-material/School";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const ScoresManagement = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { courseName, section, year } = location.state || {};

  const assessmentTypes = [
    {
      title: "Quizzes",
      icon: <QuizIcon sx={{ fontSize: 40 }}/>,
      description: "Manage quiz scores and create new quizzes",
      color: "#4CAF50",
      path: "quizzes"
    },
    {
      title: "Assignments",
      icon: <AssignmentIcon sx={{ fontSize: 40 }}/>,
      description: "Track assignment submissions and grades",
      color: "#2196F3",
      path: "assignments"
    },
    {
      title: "Exams",
      icon: <SchoolIcon sx={{ fontSize: 40 }}/>,
      description: "Record and manage exam scores",
      color: "#FF9800",
      path: "exams"
    }
  ];

  const handleCardClick = (path) => {
    navigate(`${path}/`, {
      state: { courseName, section, year }
    });
  };

  return (
    <Paper elevation={3} sx={{ p: 3, m: 2, backgroundColor: "#fff" }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 4 }}>
        <IconButton 
          onClick={() => navigate("/scores")}
          sx={{ color: "#904dd3", mr: 2 }}
        >
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h4" sx={{ color: "#904dd3", fontWeight: "500" }}>
          {courseName}
          <Typography component="span" variant="h6" sx={{ ml: 2, color: "#666" }}>
            Section {section} | {year}
          </Typography>
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {assessmentTypes.map((type, index) => (
          <Grid item xs={12} md={4} key={index}>
            <Card 
              sx={{ 
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: 'transform 0.2s, box-shadow 0.2s',
                '&:hover': {
                  transform: 'translateY(-5px)',
                  boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
                  cursor: 'pointer'
                }
              }}
              onClick={() => handleCardClick(type.path)}
            >
              <CardContent sx={{ flexGrow: 1, textAlign: 'center' }}>
                <Box 
                  sx={{ 
                    backgroundColor: `${type.color}15`,
                    borderRadius: '50%',
                    width: 80,
                    height: 80,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 16px',
                    color: type.color
                  }}
                >
                  {type.icon}
                </Box>
                <Typography variant="h5" component="h2" gutterBottom>
                  {type.title}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  {type.description}
                </Typography>
              </CardContent>
              <CardActions sx={{ justifyContent: 'center', pb: 2 }}>
                <Button 
                  variant="contained" 
                  endIcon={<ArrowForwardIcon />}
                  sx={{ 
                    backgroundColor: type.color,
                    '&:hover': {
                      backgroundColor: type.color,
                      opacity: 0.9
                    }
                  }}
                >
                  Manage {type.title}
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default ScoresManagement;